import React from 'react'
import BadgeSecondary from './BadgeSecondary.jsx'

export default function BadgeManager(props) {
	const {
		manager,
		others_managers_count = 0,
		bgColor
	} = props

	const lastName = manager?.lastName || manager?.name;
	const firstName = manager?.firstName || manager?.surname;

	return (
		<BadgeSecondary
			icon={((manager && manager.id) || 0 < others_managers_count) && <i className="fa-kit fa-equipier font-weight-normal"></i>}
			text={(manager && manager.id) ? ((firstName + ' ' + lastName).truncate(30)) : (others_managers_count == 0 ? 'add_manager'.trad() : '')}
			textSecondary={(others_managers_count && 0 < others_managers_count) ? `+ ${others_managers_count}` : null}
			bgColor={bgColor}
			color={(!(manager && manager.id) && others_managers_count == 0 ) ? 'orange' : 'gc-dark-blue'}
		/>
	);
}